import { Helmet } from 'react-helmet-async';
import { filter, reduceRight } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { useDispatch } from 'react-redux';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import api from '../api';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import CreateAndUpdateModal from '../sections/@dashboard/game/CreateAndUpdateModal';
import moment from 'moment';
import { updateGameAction } from 'src/redux/actions/masterGameAction';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { row_per_page_data } from 'src/utils/commonUtils';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'game_name', label: 'Game Name', alignRight: false },
  { id: 'open_time', label: 'Open Time', alignRight: false },
  { id: 'close_time', label: 'Close Time', alignRight: false },
  { id: 'stop_open_bid', label: 'Open Market', alignRight: false },
  { id: 'stop_close_bid', label: 'Close Market', alignRight: false },
  { id: 'market_status', label: 'Market', alignRight: false },
  { id: 'is_active', label: 'Game Active', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function MasterGamePage() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[0]);

  const [masterGameData, setMasterGameData] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = masterGameData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const getAllMasterGames = async () => {
    dispatch(loadingStartAction());
    const response = await api.get('/master-games');
    setMasterGameData(response.data.results);
    dispatch(loadingStopAction());
  };

  const updateGame = async (type, selectedGame) => {
    // dispatch(loadingStartAction());
    if (type === 'is_active' || type === 'is_disabled' || type === 'closed') {
      let reqBody = {};
      if (type === 'is_active') {
        reqBody = {
          type: 'active',
          is_active: true,
        };
      } else if (type === 'is_disabled') {
        reqBody = {
          type: 'disabled',
          is_active: false,
        };
      } else if (type === 'closed') {
        if (selectedGame.stop_open_bid || selectedGame.stop_close_bid) {
          reqBody = {
            type: 'running',
          };
        } else {
          reqBody = {
            type: 'closed',
          };
        }
      }

      console.log(reqBody,"reqBody");

      await api.put(`/master-games/${selectedGame._id}`, reqBody);
    } else if (type === 'delete') {
      if (confirm('Are you sure you want to proceed?')) {
        alert('dlele');
        // await api.delete(`/master-games/${selectedGame._id}`);
      }
    }
    getAllMasterGames();
  };

  const editgame = async () => {
    handleCloseMenu();
    dispatch(updateGameAction(selectedGame));
    getAllMasterGames();
  };

  useEffect(() => {
    getAllMasterGames();
  }, []);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - masterGameData?.length) : 0;

  const filteredFinalData = applySortFilter(masterGameData, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredFinalData.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            All Games
          </Typography>
          <CreateAndUpdateModal />
        </Stack>

        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={masterGameData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const {
                      _id,
                      market_status,
                      stop_close_bid,
                      stop_open_bid,
                      open_time,
                      close_time,
                      game_name,
                      is_active,
                    } = row;
                    const selectedUser = selected.indexOf(game_name) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, game_name)} /> */}
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            {/* <Avatar alt={game_name} src={pic} /> */}
                            <Typography variant="subtitle2" noWrap>
                              {game_name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        {/* MMMM Do, */}
                        <TableCell align="left">{moment(open_time).format('hh:mm a')}</TableCell>
                        <TableCell align="left">{moment(close_time).format('hh:mm a')}</TableCell>

                        <TableCell align="left">
                          <Label color={stop_open_bid ? 'error' : 'success'}>
                            {stop_open_bid ? 'Closed' : 'Running'}
                          </Label>
                        </TableCell>

                        <TableCell align="left">
                          <Label color={stop_close_bid ? 'error' : 'success'}>
                            {stop_close_bid ? 'Closed' : 'Running'}
                          </Label>
                        </TableCell>

                        <TableCell align="left">
                          <Button
                            size="small"
                            style={{
                              cursor: 'pointer',
                            }}
                            color="inherit"
                            onClick={(e) => {
                              updateGame('closed', row);
                            }}
                          >
                            <Label
                              style={{
                                cursor: 'pointer',
                              }}
                              color={stop_close_bid && stop_open_bid ? 'error' : 'success'}
                            >
                              {stop_close_bid && stop_open_bid ? 'Closed' : 'Running'}
                            </Label>
                          </Button>
                        </TableCell>

                        <TableCell align="left">
                          <Button
                            size="small"
                            style={{
                              cursor: 'pointer',
                            }}
                            color="inherit"
                            onClick={(e) => {
                              if (row.is_active) {
                                updateGame('is_disabled', row);
                              } else {
                                updateGame('is_active', row);
                              }
                            }}
                          >
                            <Label
                              style={{
                                cursor: 'pointer',
                              }}
                              color={!is_active ? 'error' : 'success'}
                            >
                              {is_active ? 'Active' : 'Not-Active'}
                            </Label>
                          </Button>
                        </TableCell>
                      

                        <TableCell align="right">
                          {/* <Button
                            size="large"
                            color="inherit"
                            onClick={(e) => {
                              setSelectedGame(row);
                              handleOpenMenu(e);
                            }}
                          >
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </Button> */}

                          <Button
                            size="small"
                            onClick={(e) => {
                              updateGame('delete', row);
                            }}
                          >
                            <Label
                              style={{
                                cursor: 'pointer',
                              }}
                              color="error"
                            >
                              Delete
                            </Label>
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <CreateAndUpdateModal selectedGame={selectedGame} />

        {/* 
        <MenuItem onClick={() => updateGame('is_active')} sx={{ color: 'info.main' }}>
          <Iconify icon={'eva:edit-2-outline'} sx={{ mr: 2 }} />
          Active
        </MenuItem>

        <MenuItem onClick={() => updateGame('closed')} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:edit-2-outline'} sx={{ mr: 2 }} />
          Close
        </MenuItem>
        <MenuItem onClick={() => updateGame()} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem> */}
      </Popover>
    </>
  );
}
